import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { BatchDetailPage } from "@/features/evaluation/components/BatchDetailPage"

const Params = z.object({
  batchId: z.string(),
})

export const Route = createFileRoute("/(authenticated)/settings/evaluation/batches/$batchId/")({
  params: Params,
  component: () => {
    const { batchId } = Route.useParams()
    return <BatchDetailPage batchId={batchId} />
  },
})
